import { cn } from "@/lib/cn";

interface FooterProps {
  className?: string;
}

/**
 * Footer — AppShell pastki qator (Sprint R2, plan 6.3).
 *
 * Spec:
 *  - 40px height
 *  - 3 link: Privacy / Terms / Status pill
 *  - "Data deletion" OLINIB tashlandi (Meta-spetsifik, alohida sozlamalar
 *    sahifasiga ko'chiriladi)
 *  - Bg: --bg-base, top border 1px --border-subtle
 *  - Hover: --text-secondary
 */
export function Footer({ className }: FooterProps) {
  return (
    <footer
      role="contentinfo"
      className={cn(
        "flex h-10 shrink-0 items-center justify-between gap-4 border-t border-[var(--border-subtle)]",
        "bg-[var(--bg-base)] px-6 text-[11px] text-[var(--text-muted)]",
        className,
      )}
    >
      <span>© {new Date().getFullYear()} Prism OS</span>
      <nav
        className="flex items-center gap-4"
        aria-label="Yuridik havolalar"
      >
        <a
          href="/privacy"
          className="transition-colors hover:text-[var(--text-secondary)] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[var(--brand-primary)]/60 rounded-sm"
        >
          Maxfiylik
        </a>
        <a
          href="/terms"
          className="transition-colors hover:text-[var(--text-secondary)] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[var(--brand-primary)]/60 rounded-sm"
        >
          Shartlar
        </a>
        <span
          className="inline-flex items-center gap-1.5 rounded-full border border-[var(--success-border)] bg-[var(--success-soft)] px-2 py-0.5 text-[10px] font-medium text-[var(--success-fg)]"
          title="Tizim holati"
        >
          <span
            aria-hidden
            className="inline-block h-1.5 w-1.5 rounded-full bg-[var(--success)]"
          />
          Operational
        </span>
      </nav>
    </footer>
  );
}
